import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Nereus brand colors — a deep-sea gradient that stays constant across app
 * themes so Nereus always reads as "of the ocean", even in the magenta theme.
 */
export const NEREUS_GRADIENT =
  'linear-gradient(135deg, #04365C 0%, #0E7490 55%, #14B8C4 100%)';
export const NEREUS_GRADIENT_HOVER =
  'linear-gradient(135deg, #052E4E 0%, #0C637C 55%, #0FA3AE 100%)';

/**
 * Nereus brand mark — a trident rising from cresting waves.
 *
 * Nereus is the benevolent "Old Man of the Sea" of Greek myth, so the mark is
 * his trident plunging into a rolling swell, with spray droplets breaking off
 * to either side. A second, fainter wave adds depth behind the first.
 *
 * Drawn with `currentColor` strokes, so it inherits `color`/`fontSize` from
 * MUI like any icon and works on both light and dark surfaces.
 */
const NereusIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    {/* Trident: center prong with barbed tip, outer prongs curving up from
        the shaft, shaft plunging down into the swell. */}
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 2.6 V14.8
         M9.9 4.9 L12 2.6 L14.1 4.9
         M7.2 5.2 V8.2 C7.2 10.9 9.3 12.7 12 12.7 C14.7 12.7 16.8 10.9 16.8 8.2 V5.2
         M5.9 6.8 L7.2 5.2 L8.5 6.8
         M15.5 6.8 L16.8 5.2 L18.1 6.8"
    />
    {/* Front wave the trident plunges into. */}
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      d="M2.6 16.4 C4.2 14.6 5.8 14.6 7.4 16.4 C9 18.2 10.6 18.2 12.2 16.4
         C13.8 14.6 15.4 14.6 17 16.4 C18.6 18.2 20.2 18.2 21.8 16.4"
    />
    {/* Fainter trailing swell behind it. */}
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      opacity={0.5}
      d="M4.5 20.2 C5.75 18.6 7 18.6 8.25 20.2 C9.5 21.8 10.75 21.8 12 20.2
         C13.25 18.6 14.5 18.6 15.75 20.2 C17 21.8 18.25 21.8 19.5 20.2"
    />
    {/* Spray droplets breaking off the swell. */}
    <circle cx="20.4" cy="12.4" r="0.95" fill="currentColor" />
    <circle cx="3.6" cy="12.9" r="0.7" fill="currentColor" opacity={0.6} />
  </SvgIcon>
);

export default NereusIcon;
